import { combineReducers } from 'redux';

import {
    CREATED_PRODUCT,
    FETCHED_PRODUCTS,
    UPDATED_PRODUCT,
    FETCHING_PRODUCT_LIST,
} from 'src/modules/product/actions/product.action';
import { AUTH_LOGOUT } from 'modules/auth/actions/authentication.action';

const loadingProductsList = (state = false, action) => {
    switch (action.type) {
        case FETCHING_PRODUCT_LIST:
            return action.payload;
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

const productsList = (state = {}, action) => {
    switch (action.type) {
        case FETCHED_PRODUCTS:
            return action.payload;
        case CREATED_PRODUCT:
            return {
                ...state,
                items: [
                    ...state.items,
                    action.payload,
                ],
            };
        case UPDATED_PRODUCT:
            return {
                ...state,
                items: Array.isArray(state.items)
                    ? state.items.map((product) => {
                        if (product.pk_product === action.payload.pk_product) {
                            return action.payload;
                        }
                        return product;
                    })
                    : [action.payload],
            };
        case AUTH_LOGOUT:
            return {};
        default:
            return state;
    }
};

export default combineReducers({
    productsList,
    loadingProductsList,
});
